import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { pipe } from "Utils";
import { isMainSiteCode } from "Utils/siteConfig";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import RecentlyConnectedTariffsContainer from "Containers/RecentlyConnectedTariffsContainer";
import TopProviderContainer from "Containers/TopProviderContainer";
import { PaddingTop } from "ComponentsUI/Spacings";
import { PROVIDER_TAB_CARD } from "stores/ProviderModel";
import TariffsContainer from "./containers/Tariffs";
import ReviewsContainer from "./containers/Reviews";
import ProviderFullInfo from "./containers/ProviderFullInfo";

const CardPage = (props) => {
	const {
		ApplicationModel: { providerModel, siteConfig },
		route,
	} = props;

	const siteCode = props.ApplicationModel.siteCode;

	useEffect(() => {
		if (providerModel.visibleTab !== PROVIDER_TAB_CARD) {
			providerModel.changeTab(PROVIDER_TAB_CARD);
		}
	}, []);

	const canonical = () => {
		const location = generateUrl(configRouters.ProviderDetails.route, props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	const { providerForCard } = props;

	return (
		<>
			{canonical()}
			{isMainSiteCode(siteCode) && <div></div>}
			<PaddingTop>
				<div
					style={{
						display: "block",
					}}
				>
					<TariffsContainer {...props} isCard={true} skipLayout={true} />
					<ReviewsContainer providerForCard={providerForCard} />
					<ProviderFullInfo providerForCard={providerForCard} seoData={props.seoData} />
					{!providerForCard?.info?.cnt_tariffs && (
						<>
							<SeoBlockHOC route={route} placeText="TopProvider">
								<TopProviderContainer />
							</SeoBlockHOC>

							<RecentlyConnectedTariffsContainer
								{...props}
								skipLayout={true}
								isCard={true}
								pageName={!providerForCard?.vip_provider && "no_vip_card"}
							/>
						</>
					)}
				</div>
			</PaddingTop>
		</>
	);
};

export default pipe(observer, inject("ApplicationModel"), withDefaultParams, withRouter)(CardPage);
